<template>
 <h3>7095报价</h3>
  <StockSearchForm @submit="fetchData" :isSubmitting="isSubmitting" />
    <div v-if="filteredTableData.length > 0">
      <RiskyStockTable :tableData="filteredTableData" :now_str="now_str" />
    </div>

</template>

<script>
import axios from 'axios';
import StockSearchForm from '@/components/StockSearchForm.vue';
import RiskyStockTable from '@/components/RiskyStockTable.vue';
import { formatDate } from '@/utils/commonMethods';
export default {
  name: 'App',
  components: {
    StockSearchForm,
    RiskyStockTable
  },
  data() {
    return {
      date:'',
      isSubmitting: false,
      searchQuery: '',
      warring: '',
      tableData: [],
      selectedStructure: '100%',
      selectedStructure_amount: '1',
      selectedBrokerage: 'all',  // 初始化为默认值
      selectedTimes:'1M',
       times_options: [
        { value: '2w', label: '2w' },
        { value: '1M', label: '1M' },
        { value: '2M', label: '2M' },
        { value: '3M', label: '3M' },
        { value: '6M', label: '6M' },

      ],
      total_principal: '1',  // 初始化为默认值
      total_principal_label: '100w',  // 用于存储 label 值
      containerDisplay:false,
    }
  },
   created() {
    this.stock_code = this.$route.query.stock_code || '';
    if (this.stock_code) {
      this.fetchStockData();
    } else {
      this.error = '股票代码未提供';
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalRecords / this.perPage);
    },
    filteredTableData() {
      let filteredData = this.tableData;
      return filteredData;
    },
    formattedDate() {
      return this.date ? formatDate(this.date) : '';
    }
  },
  methods: {

    async fetchData(searchQuery,date) {
      if (this.isSubmitting) return;
      console.log('开始请求数据:', searchQuery);
      this.isSubmitting = true;
      try {
        const response = await axios.get(`/api/query_risky`,{
             headers: {
                 'Authorization': `Bearer ${this.$store.getters.token}`
             },
            params: { now_date: date,code:searchQuery }

        });
        const responseData = response.data;

        if (responseData.stock_data_list == null) {
          this.$message.error(responseData.detail||'不是7095标的');
          this.data = {};
          this.tableData = [];
        } else {
          this.data = responseData;
          this.generateTableData();
          this.containerDisplay = false;
        }
      } catch (error) {
        this.warring = '数据获取失败，' + this.data.error;
      } finally {
        this.isSubmitting = false;
        console.log('请求完成');
      }
    },
    generateTableData() {
      const { date, stock_code, stock_name, stock_data_list } = this.data;
      this.now_str = this.data.now_str;
      this.scode = stock_code ? stock_code.split('.')[0] : '';

      // 确保数据存在后再进行操作
      const dataExists = stock_data_list && Object.keys(stock_data_list).length > 0;

      this.tableData = dataExists ? [
        {
          date,
          stock_code,
          stock_name,
          term: '3M',
          ...this.extractValues(stock_data_list, [2, 5,3])
        },
        {
          date: '',
          stock_code: '',
          stock_name: '',
          term: '6M',
          ...this.extractValues(stock_data_list, [3, 99,3])
        }
      ] : [];
    },
    extractValues(stock_data_list, indices) {
      console.log('indices:', indices);

      return {
        中信_7095: (stock_data_list['中信_7095'] && stock_data_list['中信_7095'][indices[1]] !== undefined)
          ? stock_data_list['中信_7095'][indices[1]]
          : 0,

        银河_7095: (stock_data_list['银河_7095'] && stock_data_list['银河_7095'][indices[0]] !== undefined)
          ? stock_data_list['银河_7095'][indices[0]]
          : 0,
          中金_7095: (stock_data_list['中金_7095'] && stock_data_list['中金_7095'][indices[2]] !== undefined)
          ? stock_data_list['中金_7095'][indices[2]]
          : 0
      };
    },
    applyBrokerageFilter() {
      // 这个方法在 computed 中的 filteredTableData 已经处理了
    }
  }
}
</script>
<style>
.filter-group {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.el-radio-group {
  display: flex;
  align-items: center;
  background: #f5f7fa;
  border-radius: 4px;
  padding: 8px 10px;
}

.filter-title {
  margin-right: 10px;
  font-size: 14px;
  color: #606266;
}

.el-radio-button {
  margin-left: 8px;
}

.el-radio-button:first-child {
  margin-left: 0;
}

.el-radio-button__inner {
  padding: 8px 15px;
}

</style>